// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "section input[data-v-1359eb86]{padding:0 1em;border-radius:4px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
